// imports
import { styled } from '@mui/material/styles';
import Link from '@mui/material/Link';
import { useDispatch, useSelector } from 'react-redux';
import { USGS_BLUE } from '../../constants/colors';
import { setSidePanelOpen } from '../../store/mapSlice';
import { RootState } from '../../store';

const StyledSkipLink = styled(Link)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  backgroundColor: USGS_BLUE,
  color: '#ffffff',
  padding: '1rem 2rem',
  zIndex: 4000,
  fontWeight: 'bold',
  textDecoration: 'none',
  transform: 'translateY(-120%)',
  transition: 'transform 200ms ease, box-shadow 200ms ease',
  borderRadius: '0 0 4px 4px',

  '&:focus': {
    transform: 'translateY(0)',
    outline: '3px solid #ffffff',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
  },
}));

/**
 * Skip Link
 *
 * Renders a skip link when user presses Tab after app load.
 * Opens the side panel (if closed) and focuses the first accordion.
 */
export default function SkipLink() {
  const dispatch = useDispatch();
  const sidePanelOpen = useSelector(
    (state: RootState) => state.map.sidePanelOpen
  );

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (!sidePanelOpen) {
      dispatch(setSidePanelOpen(true));
    }
    // Wait for the drawer to open/render before focusing
    setTimeout(() => {
      const firstAccordion = document.getElementById('NWDC-Datasets-header');
      firstAccordion?.focus();
    }, 300);
  };

  return (
    <StyledSkipLink href="#main-content" onClick={handleClick}>
      Skip to main content
    </StyledSkipLink>
  );
}
